var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center flex-column",staticStyle:{"height":"80vh"}},[_vm._v(" 此頁面不存在，請點擊下方按鈕回到首頁 "),_c('button',{staticClass:"btn btn-outline-primary mt-2",attrs:{"type":"button"},on:{"click":_vm.goHome}},[_vm._v("返回首頁")])])
}
var staticRenderFns = []

export { render, staticRenderFns }